export default {"src":"/_next/static/media/close.3b668b38.svg","height":35,"width":35,"blurWidth":0,"blurHeight":0};